<template>
  <span class="google-serp-simulator-length">
    <span
      v-if="title"
      class="google-serp-simulator-length__current-title-count"
      :class="[`google-serp-simulator-length__current-title-count_${titleClass}`]"
    >
      {{ currentTitleLength }}
    </span>
    <span
      v-if="desc"
      class="google-serp-simulator-length__current-title-count"
      :class="[`google-serp-simulator-length__current-title-count_${descClass}`]"
    >
      {{ currentDescLength }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'GoogleSerpSimulatorLength',
  props: {
    title: {
      type: String,
      default: ''
    },
    desc: {
      type: String,
      default: ''
    }
  },
  computed: {
    currentTitleLength () {
      return this.title
        ? `SEO Title Tag: ${this.title.length} of 60 characters`
        : ''
    },
    titleClass () {
      return !this.title
        ? ''
        : this.title.length > 65
          ? 'red'
          : this.title.length < 61
            ? 'green'
            : 'orange'
    },
    currentDescLength () {
      return this.desc
        ? `Description: ${this.desc.length} of 160 characters`
        : ''
    },
    descClass () {
      return !this.desc
        ? ''
        : this.desc.length > 170
          ? 'red'
          : this.desc.length < 161
            ? 'green'
            : 'orange'
    }
  }
}
</script>

<style lang="scss" scoped>
.google-serp-simulator-length {
  &__current-title-count {
    white-space: nowrap;
    color: $rfx-silver;
    font-size: 14px;
    grid-area: count;

    &:last-child {
      margin-left: 8px;
    }

    &_red {
      color: $rfx-red;
    }

    &_green {
      color: $rfx-green;
    }

    &_orange {
      color: $rfx-orange;
    }
  }
}
</style>
